import { useState } from "react";
import axios from "axios";
import { ArrowUpRight, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LeadForm({ interest = "General consultation", compact = false }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", interest, location: "Indore", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const update = (event) => setForm((current) => ({ ...current, [event.target.name]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, form);
      setSubmitted(true);
      toast.success("Thank you — an advisor will be in touch shortly.");
    } catch (error) {
      toast.error("We couldn't send that just now. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="form-success" data-testid="lead-form-success">
        <div className="success-icon"><Check size={18} /></div>
        <h3 data-testid="lead-confirmation-heading">Your next move starts here.</h3>
        <p data-testid="lead-confirmation-copy">We have your details. A Richcube Wealth Management advisor will call within one working day.</p>
        <button className="text-button" data-testid="lead-form-another-button" onClick={() => setSubmitted(false)}>Send another enquiry <ArrowUpRight size={15} /></button>
      </div>
    );
  }

  return (
    <form className={`lead-form ${compact ? "lead-form-compact" : ""}`} onSubmit={submit} data-testid="lead-capture-form">
      <div className="form-heading">
        <p className="eyebrow">PRIVATE CONVERSATION</p>
        <h3 data-testid="lead-form-heading">Let&apos;s talk about what&apos;s next.</h3>
        {!compact && <p>Share a few details and we&apos;ll pair you with the right specialist.</p>}
      </div>
      <div className="form-grid">
        <label>Name<input data-testid="lead-name-input" name="name" value={form.name} onChange={update} placeholder="Your full name" required /></label>
        <label>Phone<input data-testid="lead-phone-input" name="phone" value={form.phone} onChange={update} placeholder="+91 98765 43210" required /></label>
        <label>Email<input data-testid="lead-email-input" type="email" name="email" value={form.email} onChange={update} placeholder="you@example.com" required /></label>
        <label>Location<select data-testid="lead-location-select" name="location" value={form.location} onChange={update}><option>Indore</option><option>Goa</option><option>Other</option></select></label>
      </div>
      <label>How can we help?<select data-testid="lead-interest-select" name="interest" value={form.interest} onChange={update}><option>Commercial Leasing</option><option>Plots & Land</option><option>Warehouse Leasing & Sale</option><option>Mutual Funds</option><option>Life & Health Insurance</option><option>Share Trading</option><option>Gold Investment</option><option>General consultation</option></select></label>
      {!compact && <label>Anything we should know? <textarea data-testid="lead-message-input" name="message" value={form.message} onChange={update} placeholder="Tell us a little about your requirement" rows="3" /></label>}
      <button className="button button-gold form-submit" data-testid="lead-form-submit-button" type="submit" disabled={loading}>{loading ? <Loader2 className="spin" size={17} /> : "Request a conversation"}<ArrowUpRight size={17} /></button>
      <p className="form-note" data-testid="lead-form-privacy-note">Your details stay private. No sales pressure, ever.</p>
    </form>
  );
}